import Cookies from 'js-cookie';

// getIdToken, regresa una promesa para estar listos cuando se tenga un refresh token
export const getIdToken = () => {
  return Promise.resolve(
    Cookies.get(`${process.env.REACT_APP_API_COOKIE_CONSTANT}`)
  );
};

export const getJwtToken = tokenFunction => {
  return Promise.resolve(
    Cookies.get(`${process.env.REACT_APP_API_COOKIE_CONSTANT}`)
  ).then(jwtToken => {
    tokenFunction(jwtToken);
  });
};

export const getUserJwtId = () => {
  let mayahiiJwt =
    Cookies.get(`${process.env.REACT_APP_API_COOKIE_CONSTANT}`) !==
    undefined
      ? parseJwt(
          Cookies.get(process.env.REACT_APP_API_COOKIE_CONSTANT)
        )
      : '';
  if (mayahiiJwt) return mayahiiJwt.sub;
  return null;
};

export const parseJwt = (token = '') => {
  const Cookies = require('js-cookie');
  try {
    if (token) {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(function (c) {
            return (
              '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
            );
          })
          .join('')
      );
      return JSON.parse(jsonPayload);
    }
    return '';
  } catch (error) {
    Cookies.remove('gjw');
    window.localStorage.removeItem('zhinzwod');
    return '';
  }
};

// utilidad para generar un bearer
export const getAuthHeader = jwtCookie => {
  if (jwtCookie) {
    return {
      Authorization: jwtCookie ? `Bearer ${jwtCookie}` : 'Bearer *'
    };
  }
  let jwt = Cookies.get(
    `${process.env.REACT_APP_API_COOKIE_CONSTANT}`
  );
  return { Authorization: jwt ? `Bearer ${jwt}` : 'Bearer *' };
};

// Set Cookie
export const setCookie = jwtCookie => {
  if (jwtCookie) {
    const cookieOptions = {
      secure: false,
      expires: 1000 * 60 * 60 * 24 * 5,
      domain: '.mayahii.com',
      path: '/',
      sameSite: true
    };

    Cookies.set(
      `${process.env.REACT_APP_API_COOKIE_CONSTANT}`,
      jwtCookie,
      cookieOptions
    );
  }
  let jwt = Cookies.get(
    `${process.env.REACT_APP_API_COOKIE_CONSTANT}`
  );
  return jwt;
};

// Remove Cookie
export const removeCookieSession = url => {
  Cookies.remove(`${process.env.REACT_APP_API_COOKIE_CONSTANT}`, {
    path: '/',
    domain: '.mayahii.com'
  });
  window.location.href = url ? `/${url}` : '/';
};

export const getTimeZone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
